/**
 * @description: 设置
 * @author: hwx
 * @update: lyr
*/
<template>
    <div class="bistro-set">
        <div class="list-tit" v-show="showTit">
            <ul class="clearfix">
                <li class="col-md-3" v-for="menuItem in menu" :key="menuItem.id">
                    <span class="col-md-10" @click="titClk(menuItem.id)">{{menuItem.name}}</span>
                </li>
            </ul>
        </div>
        <div class="list-con" v-show="!showTit">
            <!-- 屏保设置 -->
            <div class="pbs-list" v-show="show1 && !showPbsEdit">
                <el-row>
                    <el-button class="jh-width130" @click="backFun">返回</el-button>
                </el-row>
                <h1>屏保设置</h1>
                <el-row>
                    <el-button type="primary" class="pull-right" @click="pbsAdd">新增屏保</el-button>
                </el-row>
                <el-table
                    v-loading="loading"
                    element-loading-text="努力加载中，请稍后..."
                    element-loading-background="rgba(0, 0, 0, 0.6)"
                    :data="pbs_table">
                    <el-table-column type="index" label="行号"></el-table-column>
                    <el-table-column prop="shop_name" label="门店"></el-table-column>
                    <el-table-column prop="resources_nums" label="图片/视频"></el-table-column>
                    <el-table-column prop="use_date" label="播放日期"></el-table-column>
                    <el-table-column prop="use_date_time" label="播放时间段"></el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <span class="text-blue" @click="pbsModify(scope.row.id)">修改</span>
                            <span class="text-blue" @click="pbsDel(scope.row.id)">删除</span>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    background
                    layout="total, prev, pager, next, jumper"
                    :page-size="GLOBAL.PAGESIZE"
                    :current-page.sync="pbs_page"
                    :total="pbs_total"
                    @current-change="getPbsTable">
                </el-pagination>
            </div>
            <div class="pbs-edit" v-show="showPbsEdit">
                <h2>{{pbs_edit_tit}}</h2>
                <el-form :model="pbs_edit_form" label-width="120px">
                    <el-form-item label="门店">
                        <el-select v-model="pbs_edit_form.shop_id" filterable placeholder="请选择门店">
                            <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="播放日期" class="usedate-wrap">
                        <div ref="usedate_main" class="usedate-main">
                            <el-input v-model="usedate_txt" class="el-ellipsis" placeholder="请选择使用日期"></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item label="播放时间段">
                        <el-input v-model="usetime_txt" class="el-ellipsis" placeholder="请选择使用时间" @click.native="pbsUsetime"></el-input>
                    </el-form-item>
                    <el-form-item label="进入屏保时间">
                        <el-input placeholder="请设置屏幕不操作多久后进入屏保" v-model="pbs_edit_form.start_slide_time"></el-input>
                        <span>秒</span>
                    </el-form-item>
                    <el-form-item label="播放间隔">
                        <el-input placeholder="请设置图片/视频间隔切换时间" v-model="pbs_edit_form.interval_time"></el-input>
                        <span>秒</span>
                    </el-form-item>
                    <el-form-item label="轮播图片/视频">
                        <el-row>
                            <el-button type="primary" id="pbsUploadBtn">上传图片/视频</el-button>
                            <span>图片尺寸：1920*1080</span>
                        </el-row>
                        <el-row class="clearfix">
                            <div class="pbs-edit-imgs" v-for="(item, index) in pbs_edit_form.resources" :key="index">
                                <img :src="item">
                                <i class="el-icon-error" @click="pbsEditImgDel(index)"></i>
                            </div>
                        </el-row>
                    </el-form-item>
                    <el-form-item>
                        <el-button @click="showPbsEdit=false">返回</el-button>
                        <el-button type="primary" @click="pbsEdit">确定</el-button>
                    </el-form-item>
                </el-form>
                <!-- 使用时间 -->
                <div class="use-time-wrap" ref="usetime_alert">
                    <h2>开始时间：</h2>
                    <select ref="starthour"></select>
                    <label class="colon">:</label>
                    <select ref="startseconds"></select>
                    <h2>结束时间：</h2>
                    <select ref="stophour"></select>
                    <label class="colon">:</label>
                    <select ref="stopseconds"></select>
                </div>
            </div>



            <!-- 管家默认设置 -->
            <div class="gms-list" v-show="show2">
                <el-row>
                    <el-button class="jh-width130" @click="backFun">返回</el-button>
                </el-row>
                <h1>管家默认设置</h1>
                <el-table
                    v-loading="loading"
                    element-loading-text="努力加载中，请稍后..."
                    element-loading-background="rgba(0, 0, 0, 0.6)"
                    :data="gms_table">
                    <el-table-column type="index" label="行号"></el-table-column>
                    <el-table-column prop="shop_name" label="门店"></el-table-column>=
                    <el-table-column label="管家是否默认为登录员工">
                        <template slot-scope="scope">
                            <el-select v-model="scope.row.ticket_shopping_guide_default" @change="gmsParamSet(scope.row)">
                                <el-option label="是" value="1"></el-option>
                                <el-option label="否" value="-1"></el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    background
                    layout="total, prev, pager, next, jumper"
                    :page-size="GLOBAL.PAGESIZE"
                    :current-page.sync="gms_page"
                    :total="gms_total"
                    @current-change="getGmsTable">
                </el-pagination>
            </div>



            <!-- 交流主题设置 -->
            <div class="jzs-list" v-show="show3 && showJzsList">
                <el-row>
                    <el-button class="jh-width130" @click="backFun">返回</el-button>
                </el-row>
                <h1>交流主题设置</h1>
                <el-form :inline="true" :model="jzs_list_form">
                    <el-form-item label="门店">
                        <el-select v-model="jzs_list_form.shop_id" filterable placeholder="请选择门店">
                            <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="主题">
                        <el-input placeholder="请输入主题名称" v-model="jzs_list_form.name"></el-input>
                    </el-form-item>
                    <el-form-item class="pull-right">
                        <el-button type="primary" @click="jzsAdd">新增交流主题</el-button>
                        <el-button type="primary" @click="getJzsTable(1)">查询</el-button>
                    </el-form-item>
                </el-form>
                <el-table
                    v-loading="loading"
                    element-loading-text="努力加载中，请稍后..."
                    element-loading-background="rgba(0, 0, 0, 0.6)"
                    :data="jzs_table">
                    <el-table-column type="index" label="行号"></el-table-column>
                    <el-table-column prop="shop_name" label="门店"></el-table-column>
                    <el-table-column prop="room_name" label="适用包厢">
                        <template slot-scope="scope">
                            {{scope.row.room_name.split(',').length > 5 ? scope.row.room_name.split(',').slice(0, 5).join(',') + '...' : scope.row.room_name}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="name" label="交流主题"></el-table-column>
                    <el-table-column prop="week_cycle_name" label="有效星期几"></el-table-column>
                    <el-table-column label="适用日期">
                        <template slot-scope="scope">
                            {{scope.row.use_everyday == 1 ? '每天' : scope.row.start_date + '~' + scope.row.end_date}}
                        </template>
                    </el-table-column>
                    <el-table-column label="适用时间">
                        <template slot-scope="scope">
                            {{scope.row.start_time + '~' + scope.row.end_time}}
                        </template>
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <span class="text-blue" @click="jzsModify(scope.row)">修改</span>
                            <span class="text-blue" @click="jzsDel(scope.row.id)">删除</span>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    background
                    layout="total, prev, pager, next, jumper"
                    :page-size="GLOBAL.PAGESIZE"
                    :current-page.sync="jzs_page"
                    :total="jzs_total"
                    @current-change="getJzsTable">
                </el-pagination>
            </div>
            <div class="jzs-edit" v-show="showJzsEdit">
                <h2>{{jzs_edit_tit}}</h2>
                <el-form :model="jzs_edit_form" label-width="120px">
                    <el-form-item label="门店">
                        <el-select v-model="jzs_edit_form.shop_id" :disabled="jzs_edit_form.shop_disabled" filterable placeholder="请选择门店" @change="jzsShopChange">
                            <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="主题">
                        <el-input placeholder="请输入交流主题内容" v-model="jzs_edit_form.name"></el-input>
                    </el-form-item>
                    <el-form-item label="适用包厢">
                        <el-input v-model="jzs_room_txt" class="el-ellipsis" clearable placeholder="请选择包厢号" @focus="jzsRoomSelect" @clear="jzsRoomDel"></el-input>
                    </el-form-item>
                    <el-form-item label="适用日期" class="jzs-usedate-wrap">
                        <div ref="jzs_usedate_main" class="jzs-usedate-main">
                            <el-input v-model="jzs_usedate_txt" class="el-ellipsis" placeholder="请选择适用日期"></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item label="适用时间">
                        <el-input v-model="jzs_usetime_txt" class="el-ellipsis" placeholder="请选择适用时间" @click.native="jzsUsetime"></el-input>
                    </el-form-item>
                    <el-form-item label="有效星期几">
                        <el-input v-model="jzs_week_txt" class="el-ellipsis" clearable placeholder="请选择有效星期几" @focus="jzsWeekSelect" @clear="jzsWeekDel"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button @click="jzsBackList">返回</el-button>
                        <el-button type="primary" @click="jzsEdit">确定</el-button>
                    </el-form-item>
                </el-form>
                <!-- 使用时间 -->
                <div class="use-time-wrap" ref="jzs_usetime_alert">
                    <h2>开始时间：</h2>
                    <el-row>
                        <el-col :span="11">
                            <el-select v-model="jzs_hour_start" filterable>
                                <el-option v-for="item in GLOBAL.HOURLIST" :key="item" :label="item" :value="item"></el-option>
                            </el-select>
                        </el-col>
                        <el-col class="el-line" :span="2">:</el-col>
                        <el-col :span="11">
                            <el-select v-model="jzs_minute_start" filterable>
                                <el-option v-for="item in GLOBAL.MINUTELIST" :key="item" :label="item" :value="item"></el-option>
                            </el-select>
                        </el-col>
                    </el-row>
                    <h2>结束时间：</h2>
                    <el-row>
                        <el-col :span="11">
                            <el-select v-model="jzs_hour_end" filterable>
                                <el-option v-for="item in GLOBAL.HOURLIST" :key="item" :label="item" :value="item"></el-option>
                            </el-select>
                        </el-col>
                        <el-col class="el-line" :span="2">:</el-col>
                        <el-col :span="11">
                            <el-select v-model="jzs_minute_end" filterable>
                                <el-option v-for="item in GLOBAL.MINUTELIST" :key="item" :label="item" :value="item"></el-option>
                            </el-select>
                        </el-col>
                    </el-row>
                </div>
                <!-- 星期 -->
                <div class="export-wrap" ref="jzs_week_alert">
                    <el-checkbox :indeterminate="jzs_week_sign" v-model="jzs_week_all" @change="jzsWeekAll">全选</el-checkbox>
                    <el-checkbox-group v-model="jzs_week_ids" @change="jzsWeekChange">
                        <el-checkbox label="1">星期一</el-checkbox>
                        <el-checkbox label="2">星期二</el-checkbox>
                        <el-checkbox label="3">星期三</el-checkbox>
                        <el-checkbox label="4">星期四</el-checkbox>
                        <el-checkbox label="5">星期五</el-checkbox>
                        <el-checkbox label="6">星期六</el-checkbox>
                        <el-checkbox label="0">星期日</el-checkbox>
                    </el-checkbox-group>
                </div>
            </div>
            <!-- 包厢号 -->
            <div class="multi-page" v-show="showJzsRoom">
                <div class="page-tit">选择包厢</div>
                <p>请选择包厢范围</p>
                <div class="multi-page-main">
                    <div class="multi-page-row">
                        <div>
                            <input type="checkbox" v-model='jzs_room_all' @click='jzsRoomAll'>
                            <span>全部</span>
                        </div>
                        <ul></ul>
                    </div>
                    <div class="multi-page-row" v-for="(items, index) in jzs_room_arr" :key="items.room_area">
                        <div>
                            <input type="checkbox" v-model='jzs_room_floor' :value="items.room_area" @click="jzsRoomFloor(items.room_area, index)">
                            <span>{{items.room_area_name}}</span>
                        </div>
                        <ul class="clearfix">
                            <li v-for="item in items.room" :key="item.id">
                                <input type="checkbox" v-model='jzs_room_item' :value="item.id">
                                <span>{{item.name}}</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="row">
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="jzsRoomBack()">返回</button>
                    <button type="button" class="btn btn-flat btn-middle btn-orange sub-margin" @click="jzsRoomSave()">确定</button>
                </div>
            </div>

        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                showTit: true,
                show1: false,
                show2: false,
                show3: false,
                loading: false,
                shop_list: [],
                platform_list: [],
				week_list: [{id: "1", name: "一"}, {id: "2", name: "二"}, {id: "3", name: "三"}, {id: "4", name: "四"}, {id: "5", name: "五"}, {id: "6", name: "六"}, {id: "0", name: "日"}],

                // 屏保设置
                showPbsEdit: false,
                pbs_page: 1,
				pbs_total: 0,
                pbs_table: [],
                pbs_edit_id: '',
                pbs_edit_tit: '',
                pbs_edit_form: {
                    shop_id: '',
                    start_slide_time: '',
                    interval_time: '',
                    resources: []
                },
				use_every_day: -1,
                usedate_txt: '',
				usedate_start: '',
				usedate_end: '',
                usetime_txt: '',
                usetime_start: '',
                usetime_end: '',

                // 管家默认设置
                gms_page: 1,
				gms_total: 0,
                gms_table: [],

                // 交流主题设置
                showJzsList: true,
                showJzsEdit: false,
                showJzsRoom: false,
                jzs_list_form: {
                    shop_id: '',
                    name: ''
                },
                jzs_page: 1,
				jzs_total: 0,
                jzs_table: [],
                jzs_edit_id: '',
				jzs_edit_tit: '',
				jzs_edit_form: {
					shop_id: '',
					shop_disabled: false,
					name: ''
				},
				jzs_room_txt: '',
				jzs_use_all_room: -1,
				jzs_room_all: false,
                jzs_room_item: [],
				jzs_c_room_item: [],
				jzs_room_floor: [],
				jzs_room_arr: [],
				jzs_room_arr_det: [],
				jzs_usedate_txt: '',
				jzs_use_every_day: -1,
				jzs_usedate_start: '',
                jzs_usedate_end: '',
                jzs_usetime_txt: '',
                jzs_usetime_start: '',
                jzs_usetime_end: '',
                jzs_hour_start: '00',
                jzs_minute_start: '00',
                jzs_hour_end: '00',
                jzs_minute_end: '00',
                jzs_week_txt: '',
				jzs_week_sign: false,
				jzs_week_all: false,
				jzs_week_ids: [],
            }
        },
        computed: {
            menu() {
                let menu = {};
                if(!$.isEmptyObject(this.$store.state.menunew)) {
                    menu = JSON.parse(this.$store.state.menunew);
                    menu.forEach(_ => {
                        if(_.id == '1215') { // 门票
                            menu = _.submenu;
                            menu.forEach(v => {
                                if(v.id == '1218') { // 设置
                                    menu = v.submenu;
                                }
                            })
                        }
                    })
                }
                return menu;
            },
        },
		watch: {
			jzs_room_item: {
				handler: function(val, oldVal) {
					const _this = this;

					if(_this.jzs_room_item.length >= _this.jzs_room_arr_det.length) {
						_this.jzs_room_all = true;
					} else {
						_this.jzs_room_all = false;
					}

					$.each(_this.jzs_room_arr, function(k, v) {
						if(_this.jzs_room_item.length >= v.room.length) {
							let num = 0;
							for(let i = 0, len = v.room.length; i < len; i++) {
								if(_this.jzs_room_item.indexOf(v.room[i].id) != -1) {
									num++;
								}
								if(i == v.room.length - 1 && num == v.room.length) {
									if(_this.jzs_room_floor.indexOf(v.room_area) == -1) {
										_this.jzs_room_floor.push(v.room_area);
									}
								} else {
									let index = '';
									index = _this.jzs_room_floor.indexOf(v.room_area);
									if(index != -1) {
										_this.jzs_room_floor.splice(index, 1);
									}
								}
							}
						} else {
							let index = '';
							index = _this.jzs_room_floor.indexOf(v.room_area);
							if(index != -1) {
								_this.jzs_room_floor.splice(index, 1);
							}
						}
					});
				},
				deep: true
			}
		},
        created: function() {
            this.getShop()
            this.getTicketPlatform()
        },
        mounted: function() {
            this.pbsImgUpload()
        },
        methods: {
            titClk: function(menu_id) {
                const _this = this

                _this.showTit = false
                _this.show1 = false
                _this.show2 = false
                _this.show3 = false
                if(menu_id == '1228') { // 屏保设置
                    _this.getPbsTable(1)
                    _this.show1 = true
                    _this.initDate('pbs')
                    _this.pbsInitTime()
                } else if(menu_id == '1229') { // 管家默认设置
                    _this.getGmsTable(1)
                    _this.show2 = true
                } else if(menu_id == '1230') { // 交流主题设置
                    _this.jzs_list_form.shop_id = _this.shop_list[0].id
                    _this.getJzsTable(1)
                    _this.show3 = true
                    _this.initDate('jzs')
                }
            },
            backFun: function() {
                this.showTit = true
                this.show1 = false
                this.show2 = false
                this.show3 = false
            },
            // 获取门店
            getShop: function() {
                const _this = this;

                Vue.axios.post('PublicData/api_getShopListByPurview', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.shop_list = res.data.response.result;
                        _this.shop_list.shift();
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },
            // 获取购票平台
            getTicketPlatform() {
                const _this = this;

                Vue.axios.post('PublicData/api_getTicketGroup', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.platform_list = res.data.response.result;
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },
			// 日期
			initDate: function(name) {
                const _this = this;

                if(name === 'pbs') {
                    $(_this.$refs.usedate_main).daterangepicker({
                        parentEl: '.usedate-wrap',
                        // drops: 'up',
                        buttonClasses: ['btn btn-default'],
                        applyClass: 'btn-small btn-orange',
                        cancelClass: 'btn-small btn-gray',
                    }, function(start, end, label) {
					    event.preventDefault()
                        _this.usedate_start = start.format('YYYY-MM-DD');
                        _this.usedate_end = end.format('YYYY-MM-DD');
                        if($(".usedate-everyday input").val() == "1") {
                            _this.usedate_txt = '每天';
                            _this.use_every_day = 1;
                            return;
                        } else {
                            _this.usedate_txt = _this.usedate_start + ' ~ ' + _this.usedate_end;
                            _this.use_every_day = -1;
                        }
                    });
                    $(".usedate-wrap .daterangepicker:last").find(".ranges").prepend(
                        '<div class="usedate-everyday">' +
                            '<input type="checkbox" />' +
                            '<label>每天</label>' +
                        '</div>'
                    );
                    $(".usedate-everyday input").click(function() {
                        if($(this).val() == "1") {
                            $(this).prop("checked", false);
                            $(this).val('');
                        } else {
                            $(this).prop("checked", true);
                            $(this).val('1');
                        }
                    });
                } else if(name === 'jzs') {
                    $(_this.$refs.jzs_usedate_main).daterangepicker({
                        parentEl: '.jzs-usedate-wrap',
                        // drops: 'up',
                        buttonClasses: ['btn btn-default'],
                        applyClass: 'btn-small btn-orange',
                        cancelClass: 'btn-small btn-gray',
                    }, function(start, end, label) {
					    event.preventDefault()
                        _this.jzs_usedate_start = start.format('YYYY-MM-DD');
                        _this.jzs_usedate_end = end.format('YYYY-MM-DD');
                        if($(".jzs-usedate-everyday input").val() == "1") {
                            _this.jzs_usedate_txt = '每天';
                            _this.jzs_use_every_day = 1;
                            return;
                        } else {
                            _this.jzs_usedate_txt = _this.jzs_usedate_start + ' ~ ' + _this.jzs_usedate_end;
                            _this.jzs_use_every_day = -1;
                        }
                    });
                    $(".jzs-usedate-wrap .daterangepicker:last").find(".ranges").prepend(
                        '<div class="jzs-usedate-everyday">' +
                            '<input type="checkbox" />' +
                            '<label>每天</label>' +
                        '</div>'
                    );
                    $(".jzs-usedate-everyday input").click(function() {
                        if($(this).val() == "1") {
                            $(this).prop("checked", false);
                            $(this).val('');
                        } else {
                            $(this).prop("checked", true);
                            $(this).val('1');
                        }
                    });
                }
			},


            /*
             * 屏保设置
             */
            // 列表
			getPbsTable: function(page) {
				const _this = this;

				_this.loading = true;
				Vue.axios.post('TicketSilde/getList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
                            "page_size": _this.GLOBAL.PAGESIZE
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.pbs_total = Number(res.data.response.result.total);
						}
						_this.pbs_table = res.data.response.result.rows;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
            },
            // 删除
			pbsDel(id) {
				const _this = this;

				layer.confirm('删除后不可恢复，确定删除吗？', {
					btn: ['确定', '取消']
				}, function() {
					Vue.axios.post('TicketSilde/delData', {
						"header": Vue.request_header,
						"request": {
							"version": Vue.version,
							"param": {
								"id": id
							}
						},
						"comment": ""
					})
					.then(res => {
						if(res.data.response.result_code == "true") {
							layer.msg('删除成功');
							_this.getPbsTable(_this.pbs_page);
						} else {
							Vue.timeoutfun(res.data.response.result_status, _this);
							layer.msg(res.data.response.error_msg);
						}
					})
					.catch(err => {
						layer.msg('出错啦');
					});
				});
            },
			// 使用时间
			pbsInitTime: function() {
				const _this = this;

				let seconds = [];
				for(let i = 0; i < 60; i++) {
					let item = {};
					item.id = (i < 10) ? '0' + i : i;
					item.text = (i < 10) ? '0' + i : i;
					seconds[i] = item;
				};
				let hour = [];
				for(let i = 0; i < 24; i++) {
					let item = {};
					item.id = (i < 10) ? '0' + i : i;
					item.text = (i < 10) ? '0' + i : i;
					hour[i] = item;
				}
				$(_this.$refs.starthour).select2({
					data: hour,
					language: "zh-CN",
					width: 'auto'
				});
				$(_this.$refs.stophour).select2({
					data: hour,
					language: "zh-CN",
					width: 'auto'
				});
				$(_this.$refs.startseconds).select2({
					data: seconds,
					language: "zh-CN",
					width: 'auto'
				});
				$(_this.$refs.stopseconds).select2({
					data: seconds,
					language: "zh-CN",
					width: 'auto'
				})
			},
			pbsUsetime: function() {
				const _this = this;
				$(_this.$refs.starthour).val(_this.usetime_start.split(':')[0]).trigger('change');
				$(_this.$refs.startseconds).val(_this.usetime_start.split(':')[1]).trigger('change');
				$(_this.$refs.stophour).val(_this.usetime_end.split(':')[0]).trigger('change');
				$(_this.$refs.stopseconds).val(_this.usetime_end.split(':')[1]).trigger('change');
				layer.confirm('', {
					type: 1,
					skin: 'public-alert-skin',
					btn: ['确定', '取消'], // 按钮
					title: '选择时间段',
					area: ['450px', ''], // 宽高
					content: $(_this.$refs.usetime_alert)
				}, function() {
					let starthour = $(_this.$refs.starthour).select2("val");
					let startseconds = $(_this.$refs.startseconds).select2("val");
					let stophour = $(_this.$refs.stophour).select2("val");
					let stopseconds = $(_this.$refs.stopseconds).select2("val");
					_this.usetime_start = starthour + ":" + startseconds;
                    _this.usetime_end = stophour + ":" + stopseconds;
                    if(_this.usetime_start == '00:00' && _this.usetime_end == '00:00') {
						_this.usetime_txt = '全天';
					} else {
						_this.usetime_txt = _this.usetime_start + " ~ " + _this.usetime_end;
					}
					layer.closeAll();
				});
            },
            // 上传图片/视频
			pbsImgUpload: function() {
				let _this = this;
				let host = '',
					dir = '',
                    file_name = '',
                    OSSAccessKeyId = '',
                    policy = '',
                    signature = '';

                let tm_loading = {};

				setTimeout(function() {
					// 实例化一个plupload上传对象
					let uploader = new plupload.Uploader({
						browse_button: 'pbsUploadBtn', // 选择文件id
						filters: {
							mime_types: [ // 文件格式限制
								{ title: "files", extensions: "jpg,jpeg,png,gif,mp4,mkv" }
							],
							// max_file_size: '2mb', // 文件大小限制
							// prevent_duplicates: true // 不允许选取重复文件
						},
						resize: {
							width: 1920,
							height: 1080
						},
						multi_selection: false, // 单选
						url: './', // OSS地址
						init: {
							// 当队列中的某一个文件正要开始上传前触发监听函数参数
							BeforeUpload: function(up, file) {},
							// 文件选择完毕触发
							FilesAdded: function(up, files) {
                                // 获取签名
								Vue.axios.post('publicData/api_getOssSignature', {
									"header": Vue.request_header,
									"request": {
										"version": Vue.version,
										"param": {
											"file": files[0].name,
											"path": 'ticket_system'
										}
									},
									"comment": ""
								})
								.then(res => {
									if(res.data.response.result_code == "true") {
										host = res.data.response.data.host
										dir = res.data.response.data.dir
                                        file_name = res.data.response.data.file_name
                                        OSSAccessKeyId = res.data.response.data.accessid
                                        policy = res.data.response.data.policy
                                        signature = res.data.response.data.signature
										const new_params = {
											'key': dir + file_name,
											'OSSAccessKeyId': OSSAccessKeyId,
											'policy': policy,
											'signature': signature,
											'success_action_status': '200', // 让服务端返回200，不然，默认会返回204
										};
										up.setOption({
											'url': host,
											'multipart_params': new_params
										});

                                        // 上传文件
                                        uploader.start();
                                        // loading
                                        tm_loading = _this.$loading({
                                            lock: true,
                                            text: '上传中，请稍后...',
                                            spinner: 'el-icon-loading',
                                            background: 'rgba(0, 0, 0, 0.7)'
                                        })
									} else {
										Vue.timeoutfun(data.response.result_status, _this);
										layer.msg(data.response.error_msg);
									}
								})
								.catch(err => {
									layer.msg("出错啦");
								});
                            },
                            // 文件上传过程中
                            UploadProgress: function(up, file) {},
							// 文件上传成功触发
							FileUploaded: function(up, file, data) {
                                tm_loading.close()
								_this.pbs_edit_form.resources.push(host + "/" + dir + file_name)
								layer.msg('上传成功');
							},
							// 错误提示
							Error: function(up, err) {
								if(err.code == -600) {
									layer.msg('请选择2mb以内的文件');
								} else if (err.code == -601) {
									layer.msg('只允许上传jpg,jpeg,png,gif,mp4,mkv文件');
								} else if (err.code == -602) {
									layer.msg('这个文件已经上传过一遍了');
								} else {
									layer.msg(err.response);
                                }
                                tm_loading.close()
							}
						}
					});
					// 初始化
					uploader.init();
				}, 20);
            },
            // 删除图片/视频
            pbsEditImgDel(index) {
                this.pbs_edit_form.resources.splice(index, 1);
            },
            // 点击新增
			pbsAdd() {
                this.pbs_edit_id = ''
                this.pbs_edit_tit = '新增屏保'
                this.pbs_edit_form = {
                    shop_id: this.shop_list[0].id,
                    start_slide_time: '',
                    interval_time: '',
                    resources: []
                }
                this.use_every_day = -1
                $(".usedate-everyday input").val("")
				$(".usedate-everyday input").prop("checked", false)
                this.usedate_txt = ''
				this.usedate_start = ''
                this.usedate_end = ''
                this.usetime_txt = ''
                this.usetime_start = ''
                this.usetime_end = ''
                this.showPbsEdit = true
			},
			// 点击修改
			pbsModify(id) {
                const _this = this;

                Vue.axios.post('TicketSilde/getData', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "id": id
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        const row = res.data.response.result

                        _this.pbs_edit_id = row.id
                        _this.pbs_edit_tit = '修改屏保'
                        _this.pbs_edit_form = {
                            shop_id: row.shop_id,
                            start_slide_time: row.start_slide_time,
                            interval_time: row.interval_time,
                            resources: row.resources.split(',')
                        }
						_this.use_every_day = row.use_every_day
						_this.usedate_start = row.start_date
						_this.usedate_end = row.end_date
						if(row.use_every_day == 1) {
							$(".usedate-everyday input").val("1")
                            $(".usedate-everyday input").prop("checked", true)
                            _this.usedate_txt = '每天';
						} else {
							$(".usedate-everyday input").val("")
							$(".usedate-everyday input").prop("checked", false)
                            _this.usedate_txt = row.start_date + '~' + row.end_date
						}
						_this.usetime_start = row.use_start_time
						_this.usetime_end = row.use_end_time
                        if(_this.usetime_start == '00:00' && _this.usetime_end == '00:00') {
						    _this.usetime_txt = '全天';
                        } else {
                            _this.usetime_txt = _this.usetime_start + " ~ " + _this.usetime_end;
                        }
                        _this.showPbsEdit = true
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },
            // 新增、修改
			pbsEdit() {
                const _this = this;

                let url = "TicketSilde/addData"
                let data = {
                    "header": Vue.request_header,
					"request": {
						"param": {
                            "shop_id": _this.pbs_edit_form.shop_id,
                            "use_every_day": _this.use_every_day,
                            "start_date": _this.usedate_start,
                            "end_date": _this.usedate_end,
                            "use_start_time": _this.usetime_start,
                            "use_end_time": _this.usetime_end,
                            "start_slide_time": _this.pbs_edit_form.start_slide_time,
                            "interval_time": _this.pbs_edit_form.interval_time,
                            "resources": _this.pbs_edit_form.resources.join(',')
						}
					},
					"comment": ""
                }
                if(_this.pbs_edit_id) {
                    data.request.param.id = _this.pbs_edit_id;
                    url = "TicketSilde/editData";
                }
                Vue.axios({
                    method: 'post',
                    url: url,
                    data: data
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        layer.msg('操作成功')
						_this.getPbsTable(_this.pbs_page)
						_this.showPbsEdit = false
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                })
            },



            /*
             * 管家默认设置
             */
			getGmsTable: function(page) {
				const _this = this;

				_this.loading = true;
				Vue.axios.post('Shop/getConfigList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
                            "page_size": _this.GLOBAL.PAGESIZE,
                            "config_type": 'ticket_shopping_guide_default'
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.gms_total = Number(res.data.response.result.count);
						}
						_this.gms_table = res.data.response.result.data;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
            },
            gmsParamSet(row) {
                const _this = this;

				Vue.axios.post('Shop/upConfig', {
                    "header": Vue.request_header,
					"request": {
						"param": {
							"id": row.shop_id,
                            "config_type": 'ticket_shopping_guide_default',
                            "config": row.ticket_shopping_guide_default
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						layer.msg('设置成功');
						_this.getGmsTable(_this.gms_page)
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
            },



            /*
             * 交流主题设置
             */
            // 列表
			getJzsTable: function(page) {
				const _this = this;

				_this.loading = true;
				Vue.axios.post('BistroLevels/getChattingRoomThemeList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
                            "page_size": _this.GLOBAL.PAGESIZE,
                            "shop_id": _this.jzs_list_form.shop_id,
                            "name": _this.jzs_list_form.name
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.jzs_total = Number(res.data.response.result.count);
						}
						_this.jzs_table = res.data.response.result.data;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
            },
            // 删除
			jzsDel(id) {
				const _this = this;

				layer.confirm('删除后不可恢复，确定删除吗？', {
					btn: ['确定', '取消']
				}, function() {
					Vue.axios.post('BistroLevels/delChattingRoomTheme', {
						"header": Vue.request_header,
						"request": {
							"version": Vue.version,
							"param": {
                                "id": id
							}
						},
						"comment": ""
					})
					.then(res => {
						if(res.data.response.result_code == "true") {
							layer.msg('删除成功');
							_this.getJzsTable(_this.jzs_page);
						} else {
							Vue.timeoutfun(res.data.response.result_status, _this);
							layer.msg(res.data.response.error_msg);
						}
					})
					.catch(err => {
						layer.msg('出错啦');
					});
				});
            },
            // 点击新增
			jzsAdd() {
                const _this = this
                _this.jzs_edit_id = ''
                _this.jzs_edit_tit = '新增交流主题'
                _this.jzs_edit_form = {
                    shop_id: _this.shop_list[0].id,
					shop_disabled: false,
					name: ''
                }
                new Promise(resolve => {
					_this.jzsRoomList(_this.jzs_edit_form.shop_id, resolve)
				})
				.then(res => {
					_this.jzs_room_txt = ''
					_this.jzs_use_all_room = -1
					_this.jzs_room_item = []
				})
				_this.jzs_usedate_txt = ''
				_this.jzs_use_every_day = -1
                $(".jzs-usedate-everyday input").val("");
                $(".jzs-usedate-everyday input").prop("checked", false);
				_this.jzs_usedate_start = ''
                _this.jzs_usedate_end = ''
				_this.jzs_usetime_txt = ''
				_this.jzs_usetime_start = ''
				_this.jzs_usetime_end = ''
                _this.jzs_week_txt = ''
                _this.jzs_week_ids = []
                _this.jzs_week_sign = false
                _this.jzs_week_all = false
                _this.showJzsList = false
                _this.showJzsEdit = true
			},
			// 点击修改
			jzsModify(row) {
                const _this = this
                _this.jzs_edit_id = row.id
                _this.jzs_edit_tit = '修改交流主题'
                _this.jzs_edit_form = {
                    shop_id: row.shop_id,
					shop_disabled: true,
                    name: row.name
                }
                new Promise(resolve => {
                    _this.jzsRoomList(_this.jzs_edit_form.shop_id, resolve)
                })
                _this.jzs_room_txt = row.room_name
                _this.jzs_use_all_room = row.all_room
                if(row.all_room == 1) {
                    _this.jzs_room_item = [];
                    _this.jzs_room_arr_det.forEach(item => {
                        _this.jzs_room_item.push(item.id);
                    });
                } else {
                    _this.jzs_room_item = row.room_id
                }
                _this.jzs_use_every_day = row.use_everyday
                _this.jzs_usedate_start = row.start_date
                _this.jzs_usedate_end = row.end_date
                if(row.use_everyday == 1) {
                    $(".jzs-usedate-everyday input").val("1");
                    $(".jzs-usedate-everyday input").prop("checked", true);
                    _this.jzs_usedate_txt = '每天'
                } else {
                    $(".jzs-usedate-everyday input").val("");
                    $(".jzs-usedate-everyday input").prop("checked", false);
                    _this.jzs_usedate_txt = row.start_date + '~' + row.end_date
                }
				_this.jzs_usetime_txt = row.start_time + '~' + row.end_time
				_this.jzs_usetime_start = row.start_time
				_this.jzs_usetime_end = row.end_time
                _this.jzs_week_ids = row.week_cycle
                _this.jzs_week_sign = _this.jzs_week_ids.length > 0 && _this.jzs_week_ids.length < _this.week_list.length;
                _this.jzs_week_all = _this.jzs_week_ids.length === _this.week_list.length;
                let week_txt = [];
                _this.week_list.forEach(_ => {
                    _this.jzs_week_ids.forEach(item => {
                        if(_.id == item) {
                            week_txt.push(_.name);
                        }
                    });
                });
                _this.jzs_week_txt = week_txt.join(',');
                _this.showJzsList = false
                _this.showJzsEdit = true
            },
            jzsShopChange(val) {
				new Promise(resolve => {
					this.jzsRoomList(val, resolve)
				})
				this.jzs_room_txt = '';
				this.jzs_use_all_room = -1;
				this.jzs_room_item = [];
			},
			// 获取包厢号
			jzsRoomList: function(shop_id, resolve) {
				const _this = this;

				Vue.axios.post('Shop/getAllRoomByArea', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"shop_id": shop_id
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						_this.jzs_room_arr = res.data.response.result;
						_this.jzs_room_arr_det = [];
						res.data.response.result.forEach(_ => {
							_.room.forEach(item => _this.jzs_room_arr_det.push(item))
						});
						resolve();
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg('出错啦');
				});
			},
			// 点击选择包厢号
			jzsRoomSelect: function(e) {
                this.jzs_c_room_item = [...this.jzs_room_item]
				// this.c_room_all = this.room_all;
				this.showJzsEdit = false
				this.showJzsRoom = true
			},
			jzsRoomDel() {
				this.jzs_room_txt = ''
				this.jzs_use_all_room = -1
				this.jzs_room_item = []
			},
			// 全选
			jzsRoomAll: function() {
				const _this = this;

				if(!_this.jzs_room_all) { // 实现全选
					_this.jzs_room_item = [];
					_this.jzs_room_arr_det.forEach(item => {
						_this.jzs_room_item.push(item.id);
					});
				} else { // 实现反选
					_this.jzs_room_item = [];
				}
			},
			// 楼层全选/反选
			jzsRoomFloor: function(id, index) {
				const _this = this;

				if(_this.jzs_room_floor.indexOf(id) == -1) {
					_this.jzs_room_arr[index].room.forEach(item => {
						if(_this.jzs_room_item.indexOf(item.id) == -1) {
							_this.jzs_room_item.push(item.id);
						}
					});
				} else {
					_this.jzs_room_arr[index].room.forEach(item => {
						let index = '';
						index = _this.jzs_room_item.indexOf(item.id);
						if(index != -1) {
							_this.jzs_room_item.splice(index, 1);
						}
					});
				}
			},
			// 确定包厢
			jzsRoomSave: function() {
				const _this = this;

				if(_this.jzs_room_all) {
					_this.jzs_room_txt = '全部';
					_this.jzs_use_all_room = 1;
				} else {
					let texts = [];
					_this.jzs_room_arr_det.forEach(_ => {
						_this.jzs_room_item.forEach(item => {
							if(_.id == item) {
								texts.push(_.name);
							}
						});
					});
					_this.jzs_room_txt = texts.join(",");
					_this.jzs_use_all_room = -1;
				}
				_this.showJzsEdit = true
				_this.showJzsRoom = false
			},
			// 返回
			jzsRoomBack: function() {
				this.jzs_room_item = [...this.jzs_c_room_item]
				this.showJzsEdit = true
				this.showJzsRoom = false
			},
			jzsUsetime: function() {
                const _this = this;

				_this.jzs_hour_start = _this.jzs_usetime_start.split(':')[0] || '00'
				_this.jzs_minute_start = _this.jzs_usetime_start.split(':')[1] || '00'
				_this.jzs_hour_end = _this.jzs_usetime_end.split(':')[0] || '00'
				_this.jzs_minute_end = _this.jzs_usetime_end.split(':')[1] || '00'
				layer.confirm('', {
					type: 1,
					skin: 'public-alert-skin',
					btn: ['确定', '取消'], // 按钮
					title: '使用时间',
					area: ['450px', ''], // 宽高
					content: $(_this.$refs.jzs_usetime_alert)
				}, function() {
					_this.jzs_usetime_start = _this.jzs_hour_start + ":" + _this.jzs_minute_start
					_this.jzs_usetime_end = _this.jzs_hour_end + ":" + _this.jzs_minute_end
					_this.jzs_usetime_txt = _this.jzs_usetime_start + " ~ " + _this.jzs_usetime_end
					layer.closeAll();
				});
			},
			// 星期
            jzsWeekSelect() {
                const _this = this;
                const c_week_ids = _this.jzs_week_ids,
                    c_week_sign = _this.jzs_week_sign,
                    c_week_all = _this.jzs_week_all;
                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['选择星期', true],
                    area: ['600px', ''], // 宽高
                    content: $(_this.$refs.jzs_week_alert),
                    cancel: function() {
                        // 右上角关闭
                        _this.jzs_week_ids = c_week_ids;
                        _this.jzs_week_sign = c_week_sign;
                        _this.jzs_week_all = c_week_all;
                    }
                }, function() {
                    let arr = [];
                    _this.week_list.forEach(item => {
                        _this.jzs_week_ids.forEach(sub => {
                            if(item.id == sub) {
                                arr.push(item.name);
                            }
                        });
                    });
                    _this.jzs_week_txt = arr.join(',');
                    layer.closeAll();
                }, function() {
                    _this.jzs_week_ids = c_week_ids;
                    _this.jzs_week_sign = c_week_sign;
                    _this.jzs_week_all = c_week_all;
                });
            },
            jzsWeekDel() {
				this.jzs_week_sign = false;
                this.jzs_week_all = false;
				this.jzs_week_ids = [];
            },
            jzsWeekAll(val) {
                let ids = [];
				this.week_list.forEach(v => {
					ids.push(v.id);
				});
				this.jzs_week_ids = val ? ids : [];
				this.jzs_week_sign = false;
			},
			jzsWeekChange(val) {
				const len = val.length;
				this.jzs_week_sign = len > 0 && len < this.week_list.length;
				this.jzs_week_all = len === this.week_list.length;
            },
            // 新增、修改
			jzsEdit() {
				const _this = this;

				let data = {
					"header": Vue.request_header,
					"request": {
						"param": {
							"shop_id": _this.jzs_edit_form.shop_id,
							"name": _this.jzs_edit_form.name,
							"all_room": _this.jzs_use_all_room,
							"room_id": _this.jzs_room_item,
							"use_everyday": _this.jzs_use_every_day,
							"start_date": _this.jzs_usedate_start,
							"end_date": _this.jzs_usedate_end,
							"start_time": _this.jzs_usetime_start,
							"end_time": _this.jzs_usetime_end,
							"week_cycle": _this.jzs_week_ids
						}
					},
					"comment": ""
				};
				if(_this.jzs_edit_id) {
					data.request.param.id = _this.jzs_edit_id;
				}
				Vue.axios({
					method: 'post',
					url: 'BistroLevels/addChattingRoomTheme',
					data: data
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						layer.msg('操作成功');
						_this.getJzsTable(_this.jzs_page);
						_this.showJzsList = true;
						_this.showJzsEdit = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg('出错啦');
				});
			},
			jzsBackList() {
				this.showJzsList = true;
				this.showJzsEdit = false;
			}

        }
    }
</script>
<style lang="less" scoped>
    .list-tit {
        span {
            width: 100%;
            border: 1px solid #CCC;
            margin: 0 0 30px;
            line-height: 50px;
            font-size: 16px;
            text-align: center;
            cursor: pointer;
            border-radius: 10px;
        }
    }
    h1 {
        text-align: center;
    }

    .el-table {
        margin-top: 20px;
    }

    .pbs-edit {
        .el-form {
            .el-select {
                width: 400px;
            }
            .el-input {
                width: 400px;
            }
            .usedate-wrap {
                position: relative;
            }
            .usedate-main {
                width: 400px;
            }
            .pbs-edit-imgs {
                position: relative;
                float: left;
                margin: 30px 30px 30px 0;
                img {
                    display: block;
                    width: 114px;
                    height: 114px;
                }
                i {
                    position: absolute;
                    right: -21px;
                    top: -21px;
                    color: #409eff;
                    font-size: 32px;
                    cursor: pointer;
                    z-index: 1999;
                }
            }
		}
    }

    .jzs-edit {
        .el-form {
            .el-select {
                width: 400px;
            }
            .el-input {
                width: 400px;
            }
            .jzs-usedate-wrap {
                position: relative;
            }
            .jzs-usedate-main {
                width: 400px;
            }
		}
    }
</style>